import { TimePeriod, TimeFilterValue } from '@hakimo-ui/hakimo/types';

export function getMHFromTimePeriod(timePeriod: TimePeriod): [number, number] {
  switch (timePeriod) {
    case TimePeriod.PAST_MINUTE:
      return [1, 0];
    case TimePeriod.PAST_HALF_HOUR:
      return [30, 0];
    case TimePeriod.PAST_HOUR:
      return [0, 1];
    case TimePeriod.PAST_SIX_HOURS:
      return [0, 6];
    case TimePeriod.PAST_12_HOURS:
      return [0, 12];
    case TimePeriod.PAST_24_HOURS:
      return [0, 24];
    case TimePeriod.PAST_WEEK:
      return [0, 24 * 7];
    case TimePeriod.PAST_MONTH:
      return [0, 24 * 30];
    case TimePeriod.PAST_THREE_MONTHS:
      return [0, 24 * 30 * 3];
    default:
      return [0, 0];
  }
}

export function getStartEndTimes(time: TimeFilterValue): [number, number] {
  let endTime: number;
  let startTime: number;

  if (time.period === TimePeriod.CUSTOM_RANGE) {
    startTime = time.customRangeStart;
    endTime = time.customRangeEnd;
  } else {
    endTime = Date.now();
    if (time.period === TimePeriod.PAST_MINUTE) {
      startTime = endTime - 60 * 1000;
    } else if (time.period === TimePeriod.PAST_HALF_HOUR) {
      startTime = endTime - 30 * 60 * 1000;
    } else if (time.period === TimePeriod.PAST_HOUR) {
      startTime = endTime - 60 * 60 * 1000;
    } else if (time.period === TimePeriod.PAST_SIX_HOURS) {
      startTime = endTime - 6 * 60 * 60 * 1000;
    } else if (time.period === TimePeriod.PAST_24_HOURS) {
      startTime = endTime - 24 * 60 * 60 * 1000;
    } else if (time.period === TimePeriod.PAST_WEEK) {
      startTime = endTime - 7 * 24 * 60 * 60 * 1000;
    } else if (time.period === TimePeriod.PAST_MONTH) {
      startTime = endTime - 30 * 24 * 60 * 60 * 1000;
    } else if (time.period === TimePeriod.PAST_THREE_MONTHS) {
      startTime = endTime - 3 * 30 * 24 * 60 * 60 * 1000;
    } else {
      startTime = endTime;
    }
  }

  return [startTime, endTime];
}
